import { render, staticRenderFns } from "./DonationForm.vue?vue&type=template&id=64d6f1ba&scoped=true"
import script from "./DonationForm.vue?vue&type=script&lang=js"
export * from "./DonationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d6f1ba",
  null
  
)

export default component.exports